import React, { PropsWithChildren } from 'react'

export const PublicLayout: React.FC<React.PropsWithChildren<PropsWithChildren>> = ({
  children,
}) => {
  return <div>{children}</div>
}
